export const MANDATORY_SIGNATURE = 'mandatorySignature';
export const PROOF_IDENTITY_SELECTED_OPTION = 'documentOption';
export const COUNTRY = 'country';
export const BIO_METRIC_STATUS = 'bioMetricStatus';
export const CONFIRM_CHECKBOX = 'confirmCheckbox';
export const DOCUMENT_OPTION = 'documentOption';
export const DOCUMENT = 'document';
//# sourceMappingURL=fieldNames.js.map